import { render, staticRenderFns } from "./DialogProduct.vue?vue&type=template&id=557d53da"
import script from "./DialogProduct.vue?vue&type=script&lang=js"
export * from "./DialogProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports